export default "/vendor/glyphicons-halflings-regular.2810d2a49be3af435f61c18c2eb4d9d0.eot";